<script>
import Category from './components/Category'
import ProductCard from './components/ProductCard'
import BoxCard from './components/ProductCard/BoxCard'
import InlineCard from './components/ProductCard/InlineCard'
import InlineBrandedCard from './components/ProductCard/InlineBrandedCard'
import responsive from '@/mixin/responsive'
import { Helper } from '@/mixin/helper'
import ContactUs from './components/ContactUs'
import * as product from '@/services/rest-api-vsms/lib/product/product'
import * as productCategory from '@/services/rest-api-vsms/lib/product/product-category'
import Layout from '@/router/layouts/main'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  page: {
    title: 'Marketplace',
  },

  components: {
    Layout,
    Category,
    ProductCard,
    BoxCard,
    InlineCard,
    InlineBrandedCard,
    ContactUs,
  },

  mixins: [Helper, responsive, MixPanel],

  data() {
    return {
      section: 'all',
      isLoading: false,
      keyword: '',
      categories: [],
      products: {},
      menu: {
        id: 1,
        label: 'marketplace.sideMenu.all',
        section: 'all',
        total: 0,
      },
      sideBar: [
        {
          id: 1,
          label: 'marketplace.sideMenu.all',
          section: 'all',
          total: 0,
        },
      ],
    }
  },

  computed: {
    title() {
      return this.$t('menuitems.marketplace.text')
    },
    sortedItems() {
      // const sorted = [...this.sideBar].sort((a, b) => a.id - b.id)
      // return sorted
      const order = ['all', 'Solusi', 'Hardware', 'Sparepart'] // Urutan yang kamu mau
      const sorted = [...this.sideBar].sort((a, b) => {
        const indexA = order.indexOf(a.section)
        const indexB = order.indexOf(b.section)

        // Kalau label-nya nggak ada di `order`, kasih nilai yang lebih tinggi (urutan berdasarkan id)
        if (indexA === -1 && indexB === -1) {
          return a.id - b.id // Urutkan berdasarkan id kalau dua-duanya nggak ada di order
        } else if (indexA === -1) {
          return 1 // Kalau a nggak ada di order, letakkan setelah b
        } else if (indexB === -1) {
          return -1 // Kalau b nggak ada di order, letakkan setelah a
        } else {
          return indexA - indexB // Urutkan sesuai dengan urutan di `order`
        }
      })
      return sorted
    },
  },

  async mounted() {
    this.track('Click Marketplace')
    await this.initData()
    this.$store.commit('marketplace/updateProductList', this.products)
    this.$store.commit('marketplace/updateCategoryList', this.categories)
    if (!this.mediaQuery.matches) {
      this.$store.dispatch('layout/toggleMenu', true)
    }
  },

  methods: {
    async initData() {
      this.isLoading = true
      // Jalankan kedua request secara paralel
      const [categories, productAll] = await Promise.all([productCategory.get(), product.get()])

      this.categories = categories.data
      const totalAll = productAll.metadata.total_count
      this.sideBar[0].total = totalAll

      const targetCategories = this.categories.reduce((acc, category) => {
        const targetCategory = category.parent_id
          ? this.categories.find((item) => item.id === category.parent_id)
          : category
        acc[category.id] = targetCategory
        return acc
      }, {})

      const parentCategories = this.categories.filter((category) => !category.parent_id)

      // Menggunakan Promise.all untuk menunggu semua async operation selesai
      const categoryPromises = parentCategories.map(async (category) => {
        let _params = {
          filters: [`product_category_id eq ${category.id}`],
        }
        if (category.display === 'inline' || category.display === 'inline-branded') {
          _params.limit = 6
        } else {
          _params.limit = 1
          const tempProducts = await product.get(_params)
          _params.limit = tempProducts.metadata.total_count
        }
        const products = await product.get(_params)
        const totalProducts = products.metadata.total_count

        const targetCategory = targetCategories[category.id]
        const categoryName = targetCategory.name

        if (!this.products[categoryName]) {
          this.products[categoryName] = []
          this.products[categoryName]['total'] = 0
        }

        this.products[categoryName].push(...products.data.paginated_result)
        this.products[categoryName]['total'] += totalProducts

        const foundSideMenuIndex = this.sideBar.findIndex((item) => item.section === categoryName)

        if (foundSideMenuIndex !== -1) {
          this.sideBar[foundSideMenuIndex].total += totalProducts
        } else {
          this.sideBar.push({
            id: 1 + targetCategory.id,
            label: categoryName,
            section: categoryName,
            total: totalProducts,
            display: targetCategory.display,
          })
        }
      })

      // Tunggu semua promises selesai
      await Promise.all(categoryPromises)

      this.$store.commit('marketplace/updateSideMenuList', this.sortedItems)
      this.isLoading = false
    },

    async handleChangeTab(data) {
      this.section = data.section
      this.products = {}
      this.menu = data
      this.isLoading = true

      const _params = {}
      if (this.keyword) {
        _params['search'] = this.keyword
      }

      const fetchProductsByCategory = async (category, categoryName) => {
        // Buat salinan params di setiap pemanggilan fungsi
        const params = { ..._params }

        // Tetapkan filter berdasarkan category.id
        params['filters'] = [`product_category_id eq ${category.id}`]

        // Atur limit sesuai dengan display category
        if (category.display === 'inline' || category.display === 'inline-branded') {
          params.limit = 6
        } else {
          params.limit = 1
          const tempProducts = await product.get(params)
          params.limit = tempProducts.metadata.total_count
        }

        const products = await product.get(params)
        const totalProducts = products.metadata.total_count

        // Simpan hasil produk ke dalam objek this.products
        if (this.products[categoryName]) {
          this.products[categoryName].push(...products.data.paginated_result)
          this.products[categoryName]['total'] += totalProducts
        } else {
          this.products[categoryName] = products.data.paginated_result
          this.products[categoryName]['total'] = totalProducts
        }
      }

      // Ambil kategori parent (yang tidak memiliki parent_id)
      const parentCategories = this.categories.filter((category) => !category.parent_id)

      // Jika section adalah 'all', ambil semua produk berdasarkan kategori
      if (this.section === 'all') {
        const categoryPromises = parentCategories.map(async (category) => {
          const targetCategory = category.parent_id
            ? this.categories.find((item) => item.id === category.parent_id)
            : category
          const categoryName = targetCategory.name
          await fetchProductsByCategory(category, categoryName)
        })
        await Promise.all(categoryPromises)
      } else {
        // Jika section bukan 'all', ambil produk berdasarkan ID yang sesuai
        const categoryPromises = parentCategories.map(async (category) => {
          if (data.id - 1 === category.id || data.id - 1 === category.parent_id) {
            const categoryName = data.section
            await fetchProductsByCategory(category, categoryName)
          }
        })
        await Promise.all(categoryPromises)
      }

      this.isLoading = false
    },

    async handleSearchChange(filter) {
      this.keyword = filter
      await this.handleChangeTab(this.menu)
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-marketplace">
      <b-row>
        <b-col xl="3" lg="3" md="4" class="mc-marketplace-sidebar">
          <Category
            :title="title"
            @marketplaceTab="handleChangeTab"
            @searchMarketplace="handleSearchChange"
          />
        </b-col>

        <b-col xl="9" lg="9" md="8" class="mc-marketplace-content">
          <b-skeleton-wrapper :loading="isLoading">
            <template #loading>
              <b-row>
                <b-col md="4">
                  <b-skeleton-img aspect="3:1" />
                </b-col>
                <b-col md="4">
                  <b-skeleton-img aspect="3:1" />
                </b-col>
                <b-col md="4">
                  <b-skeleton-img aspect="3:1" />
                </b-col>
              </b-row>
            </template>
            <h5 class="mc-general__label">
              {{ `${$t('marketplace.title')}` }}
            </h5>
            <div v-if="section === 'all'">
              <ProductCard class="my-3" :list="products" :keyword="keyword" />
            </div>
            <div v-else>
              <BoxCard
                v-if="menu.display === 'box'"
                :title="section"
                :list="products[section]"
                class="mc-marketplace-card my-3"
              />
              <InlineCard
                v-if="menu.display === 'inline'"
                :title="section"
                :list="products[section]"
                :keyword="keyword"
                class="mc-marketplace-inline my-3"
              />
              <InlineBrandedCard
                v-if="menu.display === 'inline-branded'"
                :title="section"
                :list="products[section]"
                :keyword="keyword"
                class="mc-marketplace-inline my-3"
              />
            </div>
            <ContactUs :title="$t('contactUs.title')" />
          </b-skeleton-wrapper>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
